export default "__VITE_ASSET__Td$3yd5D__"